import { formatLocalDate } from '../utils/localDateTime';
import React, { useEffect, useState } from 'react';
import { modelsNearRetirement } from '../common/aiModelRetirement';

const storageKey = 'inteloptics-model-retirement-warning';

const ModelRetirementNotifications: React.FC<{ onOpen: () => void }> = ({ onOpen }) => {
    const unread = () => modelsNearRetirement().filter(model => {
        try {
            return sessionStorage.getItem(`${storageKey}-${model.id}-${model.earliestVertexRetirement}`) !== 'shown';
        } catch {
            return true;
        }
    });
    const [pending, setPending] = useState(unread);
    useEffect(() => {
        const refresh = () => setPending(unread());
        const timer = window.setInterval(refresh, 60 * 60 * 1000);
        document.addEventListener('visibilitychange', refresh);
        return () => { window.clearInterval(timer); document.removeEventListener('visibilitychange', refresh); };
    }, []);
    const model = pending[0];
    if (!model)
        return null;
    const dismiss = () => {
        try {
            sessionStorage.setItem(`${storageKey}-${model.id}-${model.earliestVertexRetirement}`, 'shown');
        } catch { /* Session storage may be unavailable. */ }
        setPending(current => current.slice(1));
    };
    const date = formatLocalDate(model.earliestVertexRetirement);
    return <div role="status" className="fixed bottom-6 left-6 z-[210] w-[min(26rem,calc(100vw-3rem))] rounded-2xl border border-amber-300 bg-amber-50 p-5 text-amber-950 shadow-2xl">
        <div className="flex items-start justify-between gap-3"><div><p className="text-xs font-black uppercase tracking-widest text-amber-700">Model retirement warning</p>
            <p className="mt-1 text-sm font-semibold">{model.id} may retire from Vertex as early as {date}.</p>
            <button type="button" onClick={() => { onOpen(); dismiss(); }} className="mt-3 text-sm font-bold text-amber-900 underline">View Models</button></div>
            <button type="button" onClick={dismiss} aria-label="Dismiss model warning" className="rounded px-2 text-lg text-amber-700 hover:bg-amber-100">×</button></div>
    </div>;
};

export default ModelRetirementNotifications;
